// extracted by mini-css-extract-plugin
export default {"root":"BhNmlmQnxn","header":"CXd3nCBzva","title":"UBN5NnnE_M","iconWrapper":"BNCZMyOTSs","description":"TvwO1MR_a5"};